module.exports = __webpack_public_path__ + "img/block_bg_8.a5148b78.png";